import { AppBar, Toolbar, SxProps, Theme, Container } from '@mui/material';
import { ReactNode } from 'react';

interface IHeaderContainer {
  headerStyle: SxProps<Theme>;
  children: ReactNode;
}

export const HeaderContainer = (props: IHeaderContainer) => {
  const { headerStyle, children } = props;

  return (
    <AppBar sx={headerStyle} id='header-wrapper'>
      <Container maxWidth={false} sx={{ height: '100%' }}>
        <Toolbar disableGutters sx={{ height: '100%', width: '100%' }}>
          {children}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
